import { motion } from 'framer-motion';

const Biography = () => {
  const milestones = [
    {
      year: '1997',
      title: 'The Awakening',
      description: 'Identified his first corporate problem: a misaligned stapler in the supply closet. Spent 11 months over-thinking it. Generated 4 bonus problems in the process. Realized his calling.',
    },
    {
      year: '2003',
      title: 'Academic Over-Achievement',
      description: 'Earned PhD in Problematic Studies from the Institute of Advanced Problem Recognition. Dissertation: "The Unnoticed Crisis: A 847-Page Over-Analysis of Office Chair Squeaks." Committee noted it was "thorough to the point of concern."',
    },
    {
      year: '2008',
      title: 'Corporate Breakthrough',
      description: 'Consulted for a Fortune 500 company, successfully identifying 2,847 previously unknown problems and over-complicating 300 existing ones. None were solved. All were thoroughly documented. Three bonus problems were generated at no charge.',
    },
    {
      year: '2015',
      title: 'Certification Mastery',
      description: 'Became the world\'s first Certified Problem Awareness Specialist (CPAS) and Master Problem Escalation Professional (MPEP) — credentials he invented himself, from institutions he also founded.',
    },
    {
      year: '2019',
      title: 'The Real Problem Company Founded',
      description: 'Assembled a team of over-educated professionals from finance, law, medicine, engineering, and philosophy — united by a shared inability to leave well enough alone — to form the premier problem over-complication firm.',
    },
    {
      year: '2024',
      title: 'Industry Leadership',
      description: 'Recognized as the foremost authority in problem over-complication. 47,000+ problems identified globally. 0% resolution rate maintained. Average of 3 bonus problems generated per client engagement. Waiting list: 18 months.',
    },
  ];

  return (
    <section className="bg-dark-gray py-36">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl font-black text-white mb-6">A Lifetime of Problem Discovery</h2>
          <p className="text-xl text-light-gray max-w-3xl mx-auto leading-relaxed">
            Dr. Marcus Thornwell's journey began with a simple observation: the world is full of problems that people don't even realize they have. His life's work has been dedicated to making sure they find out.
          </p>
        </motion.div>

        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-8 top-0 bottom-0 w-1 bg-gold/30 hidden md:block"></div>

          <div className="space-y-16">
            {milestones.map((milestone, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="relative"
              >
                {/* Timeline Dot */}
                <div className="absolute left-5 w-7 h-7 rounded-full bg-gold border-4 border-dark-gray hidden md:block"></div>

                <div className="md:ml-24 bg-charcoal border-l-4 border-gold p-8 rounded-lg hover:bg-charcoal/80 transition-colors duration-300">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                    <h3 className="text-3xl font-bold text-white mb-2 md:mb-0">
                      {milestone.title}
                    </h3>
                    <span className="text-gold text-2xl font-black">{milestone.year}</span>
                  </div>
                  <p className="text-lg text-light-gray leading-relaxed">
                    {milestone.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="mt-20 bg-black/50 border-2 border-gold/30 rounded-lg p-12 text-center"
        >
          <p className="text-2xl text-white italic leading-relaxed mb-6">
            "I don't solve problems. I over-think them, over-complicate them, and ensure they 
            receive the recognition they deserve. And as a bonus — always as a bonus — I make sure 
            your problems never, ever run out. That is my sacred duty."
          </p>
          <div className="text-gold text-xl font-semibold">— Dr. Marcus Thornwell</div>
          <div className="text-light-gray text-sm mt-2">Founder & Chief Problem Officer</div>
        </motion.div>
      </div>
    </section>
  );
};

export default Biography;